import { Card, Table } from 'react-bootstrap';

const SalaryStructureSection = ({ employee }) => {
  const salary = employee?.salary || {};

  const formatCurrency = (amount) => {
    if (!amount || amount === '****') return '****';
    return `₹${parseFloat(amount).toLocaleString('en-IN')}`;
  };

  return (
    <Card className="mb-3">
      <Card.Header className="bg-info text-white">
        <h6 className="mb-0">Salary Structure</h6>
      </Card.Header>
      <Card.Body>
        <h6 className="mb-3">Earnings</h6>
        <Table size="sm" bordered>
          <tbody>
            <tr>
              <td>Basic Salary</td>
              <td className="text-end">{formatCurrency(salary.basicSalary)}</td>
            </tr>
            <tr>
              <td>HRA</td>
              <td className="text-end">{formatCurrency(salary.hra)}</td>
            </tr>
            <tr>
              <td>DA</td>
              <td className="text-end">{formatCurrency(salary.da)}</td>
            </tr>
            <tr>
              <td>Conveyance</td>
              <td className="text-end">{formatCurrency(salary.conveyance)}</td>
            </tr>
            <tr>
              <td>Medical Allowance</td>
              <td className="text-end">{formatCurrency(salary.medicalAllowance)}</td>
            </tr>
            {salary.otherAllowances && salary.otherAllowances.length > 0 && (
              salary.otherAllowances.map((allowance, index) => (
                <tr key={index}>
                  <td>{allowance.name}</td>
                  <td className="text-end">{formatCurrency(allowance.amount)}</td>
                </tr>
              ))
            )}
            <tr className="table-success fw-bold">
              <td>Gross Salary</td>
              <td className="text-end">{formatCurrency(salary.grossSalary)}</td>
            </tr>
          </tbody>
        </Table>

        <h6 className="mb-3 mt-4">Deductions</h6>
        <Table size="sm" bordered>
          <tbody>
            <tr>
              <td>PF</td>
              <td className="text-end">{formatCurrency(salary.pf)}</td>
            </tr>
            <tr>
              <td>ESI</td>
              <td className="text-end">{formatCurrency(salary.esi)}</td>
            </tr>
            <tr>
              <td>Professional Tax</td>
              <td className="text-end">{formatCurrency(salary.professionalTax)}</td>
            </tr>
            <tr className="table-danger fw-bold">
              <td>Total Deductions</td>
              <td className="text-end">{formatCurrency(salary.totalDeductions)}</td>
            </tr>
          </tbody>
        </Table>

        <div className="mt-4 p-3 bg-primary text-white rounded">
          <div className="d-flex justify-content-between mb-2">
            <h5>Net Salary (Take Home)</h5>
            <h5>{formatCurrency(salary.netSalary)}</h5>
          </div>
          <div className="d-flex justify-content-between">
            <h6>CTC (Cost to Company)</h6>
            <h6>{formatCurrency(salary.ctc)}</h6>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default SalaryStructureSection;
